export default __webpack_public_path__ + "static/media/lupaClear.9bc58a84.svg";